export enum LeaveType {
    SolicitacaoCliente = 1,
    AceitouOutraProposta = 2,
    ConsultorSolicitouDesligamento = 3,
    EndOfContract = 6,
    Others = 7,
    IncompatibleProfile = 8,
    Ethics = 9,
    Restructuring = 10,
    UnsatisfiedWithClientOrProject = 11,
    InternationalOpportunity = 12,
    NationalPropositionChallenge = 13,
    PoorPerformance = 14
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/LeaveType.ts